import React, { useEffect } from 'react';
import { matchPath, Route, RouteProps, useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IReduxState } from 'app/store';
import { AppLoading } from '../appLoading/appLoading';

interface PrivateRouteProps extends RouteProps {
  component: React.ComponentType<any>;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ component: Component, ...rest }) => {
  const { isLoggedIn } = useSelector((state: IReduxState) => state.login);
  const { replace } = useHistory();
  const { pathname, search } = useLocation();
  const isMatchingPath = matchPath(pathname, { path: rest.path, exact: true });
  useEffect(() => {
    if (!isLoggedIn && isMatchingPath) {
      replace(`/login/?next=${pathname}${search}`);
    }
  }, [isLoggedIn, replace, pathname, search, isMatchingPath]);

  if (!isLoggedIn && isMatchingPath) {
    return <AppLoading />
  }

  if (!isLoggedIn) {
    return null
  }

  return <Route {...rest} render={(props) => <Component {...props} />} />;
};

export default PrivateRoute;
